module.exports = __webpack_public_path__ + "static/media/hotelbooking.6e9f65b4.png";